<template>
  <v-card>
    <mrc_ess_skeleton_loader
      :loading="$store.state.uuid ? skeletonloading : false"
    >
      <v-card-text>
        <mrc_ess_switch
          :true-value="1"
          :false-value="0"
          v-if="$store.state.uuid"
          :readonly="readonly"
          v-model="list.is_used"
          :label="
            list.is_used == 1 ? $t('label_To_enable_the') : $t('label_disable')
          "
        >
        </mrc_ess_switch>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_The_name_of_the') + '*'"
              :error-messages="
                $errors(
                  'list',
                  'change_process_name',
                  requiredRule.concat(nocharacter)
                )
              "
              :readonly="readonly"
              :isNational="judegNational('change_process_name')"
              v-model="list.change_process_name"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_prompt
              :errMsg="$errors('list', 'change_table_uuid', requiredRule)"
              :rules="false"
              :disabled="readonly"
              :label="$t('label_Change_the_table') + '*'"
              obj="table_name"
              v-model="list.change_table_uuid"
            ></mrc_ess_prompt>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_autoComplete
              :errMsg="$errors('list', 'change_type_uuid', requiredRule)"
              :readonly="readonly"
              v-model="list.change_type_uuid"
              item-text="dict_label"
              item-value="dict_value"
              :label="$t('label_change_type') + '*'"
              :dropDownList="changeTypeList"
            >
            </mrc_ess_autoComplete>
            <!-- <mrc_ess_prompt :errMsg="$errors('list', 'change_type_uuid', requiredRule)"
                            :rules="false"
                            :disabled="readonly"
                            :label="$t('label_change_type') + '*'"
                            obj="change_type"
                            v-model="list.change_type_uuid"></mrc_ess_prompt> -->
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_business_processing_method') + '*'"
              :readonly="readonly"
              :isNational="judegNational('bean_method')"
              :error-messages="
                $errors('list', 'bean_method', requiredRule.concat(nocharacter))
              "
              v-model="list.bean_method"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_parameter_field') + '*'"
              :readonly="readonly"
              :isNational="judegNational('in_paras_fields')"
              :error-messages="
                $errors(
                  'list',
                  'in_paras_fields',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="list.in_paras_fields"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_server_comment_bean') + '*'"
              :error-messages="
                $errors(
                  'list',
                  'server_component_bean',
                  requiredRule.concat(nocharacter)
                )
              "
              :readonly="readonly"
              :isNational="judegNational('server_component_bean	')"
              v-model="list.server_component_bean"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_note')"
              :error-messages="$errors('list', 'remark', nocharacter)"
              :readonly="readonly"
              :isNational="judegNational('remark')"
              v-model="list.remark"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @cancel="cancel"
        v-if="!readonly"
        @success="success"
      ></mrc_ess_submitBtn>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>
<style scoped></style>
<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
import {
  getCodeLogicList,
  addCodeLogic,
  detailCodeLogic,
  updateCodeLogic,
  deleteCodeLogic,
} from "@/service/api/codeLogic.js";
import { getDataByName } from "@/service/api/data_dictionary";
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      items: [],
      list: {
        is_used: 1,
      },
      changeTypeList: [],
    };
  },
  validations: {
    list: {
      change_process_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      change_table_uuid: {
        required,
      },
      change_type_uuid: {
        required,
      },
      bean_method: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      in_paras_fields: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      server_component_bean: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
  created() {},
  async mounted() {
    await this.getChangeTypeDropDown();
    this.national("mrbase_sys_org_levels_change_process");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
  },
  methods: {
    async getChangeTypeDropDown() {
      const res = await getDataByName("buttonUse");
      if (res.code == 200) {
        this.changeTypeList = res.data.filter((item) => {
          return (
            item.dict_value == "add" ||
            item.dict_value == "delete" ||
            item.dict_value == "edit"
          );
        });
      }
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailCodeLogic({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async cancel() {
      if (this.$store.state.uuid) {
        this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "codeLogic",
            });
          })
          .catch((err) => {});
      }
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      if (this.$store.state.uuid) {
        updateCodeLogic(this.$deletefield(null, this.list)).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getDetail();
            this.$emit("changeReadonly");
          }
        });
      } else {
        addCodeLogic(this.list).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "codeLogic" });
          }
        });
      }
    },
  },
  computed: {},
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_code_logic_configuration";
          this.$store.commit(
            "set_page_title",
            "label_edit_code_logic_configuration"
          );
        } else {
          this.$route.meta.title = "label_view_code_logic_configuration";
          this.$store.commit(
            "set_page_title",
            "label_view_code_logic_configuration"
          );
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
